var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      Object.keys(_vm.providerWarnings).length > 0 && !_vm.debtMessage
        ? _c(
            "div",
            { attrs: { id: "provider-warnings" } },
            _vm._l(_vm.providerWarnings, function (message, title) {
              return _c("b-notification", {
                key: title,
                staticClass: "m-5",
                attrs: {
                  type: "is-warning",
                  "has-icon": "",
                  "aria-close-label": "Close message",
                  message: "<b>" + title + "</b><br/>" + message,
                },
              })
            }),
            1
          )
        : _vm._e(),
      _c("Spinner", { attrs: { "is-loading": _vm.isLoading } }),
      !_vm.isLoading
        ? _c("div", [
            _vm.debtMessage
              ? _c(
                  "div",
                  { staticClass: "notification-content" },
                  [
                    _c("WalletBalance", {
                      attrs: {
                        "client-balance":
                          _vm.$store.state.paymentsModule.clientBalance,
                      },
                    }),
                    _c("Message", {
                      attrs: {
                        message: _vm.debtMessage.message,
                        icon: _vm.debtMessage.icon,
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "card-item" },
                  [
                    _vm.relatedTransactions &&
                    _vm.relatedTransactions.length > 0
                      ? _c("RelatedTransactions", {
                          staticClass: "card-item",
                          attrs: {
                            "related-transactions": _vm.relatedTransactions,
                            "payment-providers": _vm.paymentProviders,
                            "cancel-related-transaction-button":
                              _vm.checkUserFeature(
                                "element.pay-here.button.cancel-related-transaction"
                              ) || _vm.currentUser.user.rol === "CLIENT"
                                ? _vm.cancellingRelatedTransaction
                                : "disabled",
                          },
                          on: {
                            "open-cancel-transaction-modal": function ($event) {
                              return _vm.$emit(
                                "open-cancel-transaction-modal",
                                $event
                              )
                            },
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _vm._m(0),
                        _c("WalletBalance", {
                          staticClass: "wallet-balance",
                          attrs: {
                            "client-balance":
                              _vm.$store.state.paymentsModule.clientBalance,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.creditList.length !== 0
                      ? _c("ClientOperations", {
                          attrs: {
                            "payments-map": _vm.paymentsMap,
                            operations: _vm.creditList,
                            "current-loading-payment":
                              _vm.currentLoadingPayment,
                            "all-check-boxes-are-disabled":
                              _vm.allCheckBoxesAreDisabled,
                          },
                          on: {
                            change: _vm.onChange,
                            "confirm-deselect-payment": function ($event) {
                              return _vm.$emit(
                                "confirm-deselect-payment",
                                $event
                              )
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-text" }, [
      _c("h3", [_vm._v("Selecciona las cuotas")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }